import React, { useState, useEffect, useRef } from "react";
import { Textarea } from "@headlessui/react";

const AutoTextArea = (props: any) => {
  const { value = "", onChange, autoFocus = false } = props;
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const [textAreaHeight, setTextAreaHeight] = useState("auto");
  const [textValue, setTextValue] = useState(value);

  useEffect(() => {
    setTextAreaHeight(`${textAreaRef?.current?.scrollHeight}px`);
  }, [value]);

  // Auto focus when autoFocus prop is true
  useEffect(() => {
    if (autoFocus && textAreaRef.current) {
      // Use requestAnimationFrame to ensure component is fully rendered
      requestAnimationFrame(() => {
        textAreaRef.current?.focus();
      });
    }
  }, [autoFocus]);

  const handleOnChange = (event: any) => {
    if (event.key == "Enter") {
      onChange(textValue);
    }
  };

  return (
    <Textarea
      className={`w-full border border-gray-400 rounded p-2 ${props.className}`}
      {...props}
      value={textValue}
      ref={textAreaRef}
      style={{
        height: textAreaHeight,
        minHeight: props.rows * 24,
      }}
      onChange={(e) => {
        setTextValue(e.target.value);
      }}
      onKeyDown={handleOnChange}
      onBlur={() => {
        if (value != textValue) {
          onChange(textValue);
        }
      }}
    ></Textarea>
  );
};

export default AutoTextArea;
